<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
  import { useMainStore } from "../store";
  import type { QuizData, Answer } from '../types';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import { trackQuizQuestion, trackQuizAnswerSkip } from '../analytics/events';

  const store = useMainStore();
  const question = store.currentQuestion;

  const handleAnswer = (answer: Answer) => {
    const isDuplicate = store.questionAnswers.some(
      ([qId, a]) => qId === question.id && a === answer[0]
    );
    const isSkip = answer[4] === true;

    if (!isDuplicate) {
      // One canonical event per user action: skip-flagged answers fire ONLY quiz_answer_skip,
      // regular answers fire ONLY quiz_question. Keeps GA4 funnel rates clean.
      const payload = {
        quiz_id: store.quizData.quiz_id,
        question_index: store.currentIndex,
        question_text: question.title,
        answer_text: String(answer[1]),
      };
      if (isSkip) {
        trackQuizAnswerSkip(payload);
      } else {
        trackQuizQuestion(payload);
      }
    }

    store.pushQuestionAnswer([question.id, answer[0]]);

    // Se tem skip=true, vai direto para a página de destino
    if (isSkip) {
      store.redirectToLanding();
      return;
    }

    store.checkRoutes();
  };

  const isSelected = (answerId: string) => {
    return store.questionAnswers.some(([, answer]) => answer === answerId);
  };

  const quiz = store.quizData as QuizData;
</script>

<template>
  <div class="quiz-container">
    <!-- Cabeçalho do Quiz -->
    <div v-if="store.currentStep == 1">
      <h1 class="main-title">{{ quiz.title }}</h1>
      <p v-if="quiz.sub_title" class="subtitle">
        {{ quiz.sub_title }}
      </p>
    </div>

    <!-- Questão -->
    <div v-if="question" class="question-wrapper">
      <h2 class="question-title">{{ question.title }}</h2>

      <!-- Opções -->
      <div class="options-wrapper">
        <button
          v-for="answer in question.answers"
          :key="answer[0]"
          class="option-button"
          :class="{ 'selected': isSelected(answer[0]) }"
          @click="handleAnswer(answer)"
        >
          <div class="radio"></div>
          <div class="answer-content">
            <font-awesome-icon 
              v-if="answer[2]" 
              :icon="answer[2]" 
              class="answer-icon"
              :style="{ color: answer[3] || '#000000' }"
            />
            <span class="answer-text">{{ String(answer[1]) }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>